import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const promotionsImporterSelectors = importerSelectors(
  'promotions.importer',
)

export default promotionsImporterSelectors
